import {
  Component,
  inject,
  type OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

export type SnackType = 'success' | 'warning' | 'error';

export interface CustomSnackbarData {
  snackType: SnackType;
  message: string;
}

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, MatButtonModule],
})
export class CustomToastComponent implements OnInit {
  private readonly matSnack = inject(MatSnackBar);
  readonly data: CustomSnackbarData = inject(MAT_SNACK_BAR_DATA);
  snackType: SnackType = 'success';

  ngOnInit() {
    this.snackType = this.data.snackType;
  }

  close() {
    this.matSnack.dismiss();
  }
}
